import React, { useState, useEffect } from 'react'
import { createModel } from 'hox'
import useGlobalModel from '@/model/globalModel'
import { purchaseDrService } from '../../purchaseDrService'
import { convertRes2Blob } from '@/utils/exportFile'
import { message } from 'antd'
import { useLockFn } from 'ahooks'
import { ISCMPurchaseDrFormFields, ISCMPDrGoodsDetail, ISCMPurchaseDrInsert, ISCMPurchaseDrUpdate } from '../../purchaseDrTypes'
import { ISCMPDrSelectGoods } from './AddGoodsModal'
import { globalPrompt } from '@/components/message'
import { CLIENT_APP_CODE } from '@/utils/constants'
import { bigNumber, formatNum } from '@/utils/utils'
import { DictCodeEnmu } from '@/types/VrmSaDictEnums'

export type ISCMPDrDescType = {
    numAll: number
    amountAll: number
    actualAmount: number
    totalPreAmount: number;
    [key: string]: any
}
const initDesc = {
    actualAmount: 0, //实际总价合计 （数量*单价）
    //对应展示字段
    numAll: 0, //调拨数量
    amountAll: 0, //调拨总计   （去除下浮）
    totalPreAmount: 0, //实际总价合计 （数量*单价）
}

export const usePurchaseDrDetailsModel = createModel(function () {
    const {
        beShopDs,
        shopAndOrg: { shopId, shopCode, shopName },
        user: { userName },
    } = useGlobalModel()

    const initFormVal = {
        shopCode,
        shopName,
        createUser: userName,
        applier: userName,
        discountTotalAmount: '0.00', //优惠总额
        favorableAmount: '0', //整单优惠
        aggregateAmount: '0.00', //应付金额
        discountRate: '0', //整单下浮
        bentityName: beShopDs.find((item: any) => item.value === "bentity.hd")?.label ?? "",
        bentityCode: "bentity.hd",
        outBentityName: beShopDs.find((item: any) => item.value === "bentity.hd")?.label ?? "",
        outBentityCode: "bentity.hd",
        transferTypeName: '备品调拨',
        transferTypeCode: DictCodeEnmu.TRANSFER_TYPE_BP,
        branchIn: "vrm",
        branchOut: 'vrm',
    } as ISCMPurchaseDrFormFields

    //编辑缓存
    const [editFormVal, setEditFormVal] = useState<ISCMPurchaseDrFormFields>(initFormVal)
    const [editGoodsList, setEditGoodsList] = useState<ISCMPDrGoodsDetail[]>([])
    const [editDesc, setEditDesc] = useState<ISCMPDrDescType>(initDesc)
    const [isCancel, setIsCancel] = useState<boolean>(false) //记录单子是否是已作废状态

    //新增缓存
    const [addFormVal, setAddFormVal] = useState<ISCMPurchaseDrFormFields>(initFormVal)
    const [addGoodsList, setAddGoodsList] = useState<ISCMPDrGoodsDetail[]>([])
    const [addDesc, setAddDesc] = useState<ISCMPDrDescType>(initDesc)
    const [addOutShopCode, setAddOutShopCode] = useState<boolean>(false) //是否选择调出站点
    useEffect(() => {
        setAddFormVal({ ...initFormVal, shopId, shopName });
    }, [shopId])
    // 控制按钮
    const [buttonControl, setButtonControl] = useState<boolean>(false)
    // 控制保存按钮
    const [saveBtn, setSaveBtn] = useState<boolean>(false)
    // 保存按钮的loading
    const [saveBtnLoading, setSaveBtnLoading] = useState<boolean>(false)

    useEffect(() => {
        let newDesc: ISCMPDrDescType = { ...initDesc }
        editGoodsList.forEach((item) => {
            // newDesc.numAll += Number(item.num);
            newDesc.numAll = +bigNumber.add(item.num, newDesc.numAll);
            // newDesc.amountAll += Number(item.amount);
            newDesc.amountAll = +bigNumber.add(item.amount, newDesc.amountAll);
            // newDesc.actualAmount += Number(item.num) * Number(item.price);
            newDesc.actualAmount = +bigNumber.add(bigNumber.times(item.num, item.price), newDesc.actualAmount);
            // newDesc.totalPreAmount += Number(item.num) * Number(item.prePrice);
            newDesc.totalPreAmount = +bigNumber.add(bigNumber.times(item.num, item.prePrice), newDesc.totalPreAmount);
        })
        setEditDesc(newDesc)
    }, [editGoodsList])

    useEffect(() => {
        let newDesc: ISCMPDrDescType = { ...initDesc }
        addGoodsList.forEach((item) => {
            // newDesc.numAll += Number(item.num);
            newDesc.numAll = +bigNumber.add(item.num, newDesc.numAll);
            // newDesc.amountAll += Number(item.amount);
            newDesc.amountAll = +bigNumber.add(item.amount, newDesc.amountAll);
            // newDesc.actualAmount += Number(item.num) * Number(item.price);
            newDesc.actualAmount = +bigNumber.add(bigNumber.times(item.num, item.price), newDesc.actualAmount);
            // newDesc.totalPreAmount += Number(item.num) * Number(item.prePrice);
            newDesc.totalPreAmount = +bigNumber.add(bigNumber.times(item.num, item.prePrice), newDesc.totalPreAmount);
        })
        setAddDesc(newDesc)
    }, [addGoodsList])

    useEffect(() => {
        resetAddCatch()
        setAddFormVal({ ...initFormVal, shopId, shopName, createUser: userName })
    }, [shopId])

    //表单新增修改
    const updateAddFormVal = (val: object | null) => {
        val ? setAddFormVal({ ...addFormVal, ...val }) : setAddFormVal(initFormVal)
    }
    //表单编辑修改
    const updateEditFormVal = (val: object | null) => {
        val ? setEditFormVal({ ...editFormVal, ...val }) : setEditFormVal(initFormVal)
    }

    //重置缓存
    const resetEditCatch = () => {
        updateEditFormVal(null) //表单
        setEditGoodsList([]) //详情商品列表
        setEditSelectGoods([]) //弹框已选商品
    }
    const resetAddCatch = () => {
        updateAddFormVal(null)
        setAddGoodsList([])
        setAddSelectGoods([])
    }

    //获取一条数据
    const getPDrDetailOne = async (id: string) => {
        let { retData } = await purchaseDrService.one(id)
        let { details, ...formVal } = retData
        if (retData) {
            setEditGoodsList(() => details.map((item) => ({ ...item, key: item.id, isHave: true })))
            let fileList: any = []
            let fileInList: any = []
            const { inMd5, inName, outMd5, outName } = formVal
            if (inMd5) {
                fileList = [
                    {
                        uid: inMd5,
                        status: 'done',
                        name: inName,
                        response: {
                            retData: inMd5,
                        },
                    },
                ]
            }
            if (outMd5) {
                fileInList = [
                    {
                        uid: outMd5,
                        status: 'done',
                        name: outName,
                        response: {
                            retData: outMd5,
                        },
                    },
                ]
            }
            formVal.fileList = fileList
            formVal.fileInList = fileInList
            setEditFormVal(formVal)
        }
        return retData
    }

    //表单配件校验 (开单数量不能为0)
    const verifyGoods = (mode: string): boolean => {
        let goods = mode === 'edit' ? editGoodsList : addGoodsList
        if (!goods.length) {
            message.warning('请添加商品明细')
            return false
        }
        let zeroNum = goods.filter((item) => !+item.num)
        if (zeroNum.length) {
            message.warning(`【${zeroNum.map((item) => item.materialName).join()}】配件的开单数量不能为0`)
            return false
        }
        return true
    }
    //表单计算校验 (计算主单信息与配件每一项)
    const formComputeRule = (mode: string): boolean => {
        let goods = mode === 'edit' ? editGoodsList : addGoodsList
        let { actualAmount } = (mode === 'edit' ? editDesc : addDesc) as { actualAmount: number }
        actualAmount = +formatNum(actualAmount) //应付金额
        let goodsTotal: number = 0
        goods.forEach((item) => {
            let { amount } = item as { amount: number }
            goodsTotal += +amount
        })
        if (+formatNum(goodsTotal) !== actualAmount) {
            message.warning(`详情调拨金额${+formatNum(goodsTotal)}与表单调拨金额不符`)
            return false
        }
        return true
    }
    //新增 Api
    const insertPDr = useLockFn(async (val: ISCMPurchaseDrFormFields) => {
        if (val.shopCode === val.outShopCode) {
            message.warning('调入站点和调出站点不能为同一个')
            return false
        }
        setSaveBtnLoading(true)
        try {
            let data: ISCMPurchaseDrInsert = {
                ...val,
                shopId,
                details: addGoodsList.map((item) => {
                    let { key, error, isHave, msg, ...params } = item
                    return params
                }),
                inAndOut: '0',
                totalPreAmount: formatNum(addDesc['totalPreAmount'])
            }
            let { retData, success } = await purchaseDrService.insert(data)
            let { id: res, materialList } = retData
            if (success) {
                setSaveBtnLoading(false)
                setSaveBtn(false)
                if (!materialList) {
                    globalPrompt('message', {
                        text: `调入单新增成功,转换到可编辑详情页`,
                        type: 'success',
                        duration: 3,
                    })
                } else {
                    globalPrompt('message', {
                        text: `${data.shopName}没有【${materialList.map((item: any) => item.code).join()}】该配件,将自动添加至配件档案，请及时修正对应档案信息`,
                        type: 'success',
                        duration: 10,
                    })
                }
            } else {
                globalPrompt('message', { text: '调入单新增失败', type: 'error' })
                setSaveBtnLoading(false)
                setSaveBtn(false)
            }
            return res
        } catch (error) {
            setSaveBtnLoading(false)
            setSaveBtn(false);
        }
    })

    //编辑 Api
    const updatePDr = useLockFn(async (val: ISCMPurchaseDrFormFields & { id: string }) => {
        setSaveBtnLoading(true)
        try {
            let data: ISCMPurchaseDrUpdate = {
                ...editFormVal,
                ...val,
                id: editFormVal.id,
                updateUser: userName,
                shopId,
                details: editGoodsList.map((item) => {
                    let { key, error, isHave, msg, ...params } = item
                    return params
                }),
                totalPreAmount: formatNum(editDesc['totalPreAmount'])

            }
            let { success, retData } = await purchaseDrService.update(data)
            let { materialList } = retData
            if (success) {
                setSaveBtnLoading(false)
                if (!materialList) {
                    globalPrompt('message', {
                        text: `调入单编辑成功`,
                        type: 'success',
                        duration: 3,
                    })
                } else {
                    globalPrompt('message', {
                        text: `${data.shopName}没有【${materialList.map((item: any) => item.code).join()}】该配件,将自动添加至配件档案，请及时修正对应档案信息`,
                        type: 'success',
                        duration: 10,
                    })
                }
                setButtonControl(false)
                getPDrDetailOne(editFormVal.id)
                setSaveBtn(false)
            } else {
                globalPrompt('message', { text: '调入单编辑失败', type: 'error' })
            }
            return success
        } catch (error) {
            setSaveBtnLoading(false)
        }
    })

    /**
     * 商品新增
     */
    const [addGoodsModal, setAddGoodsModal] = useState<boolean>(false) //商品弹框
    const [editSelectGoods, setEditSelectGoods] = useState<ISCMPDrSelectGoods[]>([]) //已选的商品
    const [addSelectGoods, setAddSelectGoods] = useState<ISCMPDrSelectGoods[]>([]) //已选的商品

    //添加商品  默认数量字段为1
    const add = async (record: ISCMPDrSelectGoods, mode: string) => {
        const isEdit: boolean = mode === 'edit'
        let params = {
            details: [
                {
                    shopId,
                    materialCode: record.materialCode,
                },
            ],
        }
        let { retData } = await purchaseDrService.vrm2StockQuery(params)
        let { inWarehouseCode, inWarehouseName, inShelfCode, inShelfId } = retData[0]
        isEdit
            ? setEditSelectGoods((origin) => [...origin, { ...record, pDrNum: 1, inWarehouseCode, inWarehouseName, inShelfCode, inShelfId }])
            : setAddSelectGoods((origin) => [...origin, { ...record, pDrNum: 1, inWarehouseCode, inWarehouseName, inShelfCode, inShelfId }])
    }

    //删除商品 选中的
    const remove = (record: ISCMPDrSelectGoods, mode: string) => {
        if (mode === 'edit') {
            const filterSelectGoods = editSelectGoods.filter((item) => item.id !== record.id)
            setEditSelectGoods(filterSelectGoods)
        } else {
            const filterSelectGoods = addSelectGoods.filter((item) => item.id !== record.id)
            setAddSelectGoods(filterSelectGoods)
        }
    }

    //选中的配件转商品
    const transformsToPDrGoods = useLockFn(async (selectList: ISCMPDrSelectGoods[], mode: string) => {
        // debugger
        const isEdit: boolean = mode === 'edit'
        const newDetailData: ISCMPDrGoodsDetail[] = []
        let formVal = mode === 'add' ? addFormVal : editFormVal
        let branchIn = 'vrm'
        let inShopId = formVal.shopId ?? shopId
        let codeList: string[] = []
        let goodsList = mode === 'add' ? addSelectGoods : editSelectGoods
        goodsList.forEach((item) => {
            codeList.push(item.materialCode)
        })
        if (codeList.length === 0) {
            setAddGoodsModal(false)
            return
        }
        let data = {
            shopId: inShopId,
            checkoutMaterialCodeList: codeList,
            existMaterialCodeList: [],
            notExistMaterialCodeList: [],
        }
        let { retData } = await purchaseDrService.check(branchIn, data)
        let { existMaterialCodeList } = retData
        selectList.forEach((item) => {
            newDetailData.push({
                isHave: existMaterialCodeList.indexOf(item.materialCode) > -1,
                id: '',
                key: item.id,
                brandName: item.brandName,
                brandCode: item.brandCode,
                purchaseDetailsId: item.id,
                materialCode: item.materialCode,
                materialName: item.materialName,
                replaceCode: item.replaceCode,
                typeCode: item.typeCode,
                typeName: item.typeName,
                unitCode: item.unitCode,
                unitName: item.unitName,
                num: item.pDrNum,
                price: item.price ?? 0, //进货价
                prePrice: item.price ?? 0, //折前单价
                preAmount: +item.pDrNum * +(item.price ?? 0), //总计
                costPrice: item.price ?? 0, //成本单价
                favorableAmount: '0', //单品优惠         ·+++
                discountRate: '0', //下浮
                amount: +item.pDrNum * +(item.price ?? 0), //总计
                outShelfId: item.shelfId,
                outShelfCode: item.shelfCode,
                outWarehouseName: item.warehouseName,
                outWarehouseCode: item.warehouseCode,
                inWarehouseCode: item.inWarehouseCode,
                inWarehouseName: item.inWarehouseName,
                inShelfCode: item.inShelfCode,
                inventoryNum: item.inventoryQuantity,
                inShelfId: item.inShelfId,
                purchaseCode: item.purchaseCode ?? item.bussCode,
                bussCode: item.bussCode,
                bussType: item.bussType,
                note: '',
            })
        })
        isEdit ? setEditGoodsList((origin) => [...origin, ...newDetailData]) : setAddGoodsList((origin) => [...origin, ...newDetailData])
        isEdit ? setEditSelectGoods([]) : setAddSelectGoods([])
        setAddGoodsModal(false)
    })
    //调入
    const inWhConfirm = useLockFn(async (val: ISCMPurchaseDrFormFields & { id: string }) => {
        // await updatePDr(val)
        let obj = {
            inAndOut: '0',
            id: editFormVal.id,
            status: editFormVal.status,
            transferIn: userName,
            transferOut: editFormVal.transferOut,
            transferOutTime: editFormVal.transferOutTime, //调出时间
            transferInTime: editFormVal.transferInTime, //调入时间
            createUser: userName,
            transferOutCode: editFormVal.transferOutCode,
            transferInCode: editFormVal.transferInCode,
        }
        let data: ISCMPurchaseDrUpdate = {
            ...editFormVal,
            ...val,
            id: editFormVal.id,
            transferIn: userName,
            inAndOut: '0',
            transferOut: editFormVal.transferOut,
            details: editGoodsList.map((item) => {
                let { key, ...params } = item
                return params
            }),
        }
        let updatDdata: ISCMPurchaseDrUpdate = {
            ...editFormVal,
            ...val,
            id: editFormVal.id,
            updateUser: userName,
            shopId,
            details: editGoodsList.map((item) => {
                let { key, ...params } = item
                return params
            }),
        }
        let { retData: updateRedata } = await purchaseDrService.update(updatDdata)
        let { retData } = await purchaseDrService.vrm2WhConfirm(data)
        if (retData) {
            let { retData: WhConfirmRetData } = await purchaseDrService.whConfirm(obj)
            if (WhConfirmRetData) {
                message.success('调入成功')
                getPDrDetailOne(editFormVal.id)
            }
        }
    })

    //明细下载模板
    const pDrDownload = async () => {
        let result = await purchaseDrService.downloadTpl()
        convertRes2Blob(result)
    }

    //导出明细
    const exportPDrdetail = async () => {
        let result = await purchaseDrService.exportDetail(editFormVal?.code ?? '')
        convertRes2Blob(result)
    }

    /**
     * 打印
     */
    const [print, setPrint] = useState<boolean>(false)
    const [historyVisible, setHistoryVisible] = useState<boolean>(false)
    const [historyRow, setHistoryRow] = useState<any>({})
    const [addTempShelfModal, setAddTempShelfModal] = useState<boolean>(false)



    return {
        editFormVal,
        addFormVal,
        addGoodsModal,
        isCancel,
        setAddGoodsModal,
        setEditFormVal,
        setAddFormVal,
        updateAddFormVal,
        updateEditFormVal,
        resetEditCatch,
        resetAddCatch,
        /**api */
        insertPDr,
        updatePDr,
        getPDrDetailOne,
        pDrDownload,
        exportPDrdetail,
        /**商品详情 */
        editSelectGoods,
        setEditSelectGoods,
        addSelectGoods,
        setAddSelectGoods,
        addGoodsList,
        setAddGoodsList,
        editGoodsList,
        setEditGoodsList,
        add,
        remove,
        verifyGoods,
        transformsToPDrGoods,
        editDesc,
        addDesc,
        print,
        setPrint,
        inWhConfirm,
        addOutShopCode,
        setAddOutShopCode,
        historyVisible,
        setHistoryVisible,
        historyRow,
        setHistoryRow,
        addTempShelfModal,
        setAddTempShelfModal,
        formComputeRule,
        buttonControl,
        setButtonControl,
        saveBtn,
        setSaveBtn,
        saveBtnLoading,
        setSaveBtnLoading,
    }
})
